import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner } from '@chakra-ui/react';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
export const PodcastNumberRedirect = props => {
  const $ = _c(9);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($episodeNumber: Float) {
        podcastEpisodes(where: { number: $episodeNumber }) {
          id
          number
          slug
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = parseFloat(`${props.episodeNumber}`);
  let t2;
  if ($[1] !== t1) {
    t2 = {
      variables: {
        episodeNumber: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const query = useQuery(t0, t2);
  let t3;
  if ($[3] !== query.data?.podcastEpisodes || $[4] !== router) {
    t3 = () => {
      if (query.data?.podcastEpisodes && query.data?.podcastEpisodes[0]?.slug) {
        router.push(`/podcast/${query.data?.podcastEpisodes[0].slug}`);
      }
    };
    $[3] = query.data?.podcastEpisodes;
    $[4] = router;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = query.data?.podcastEpisodes;
  let t5;
  if ($[6] !== t4) {
    t5 = [t4];
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t3, t5);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Center padding="1em" width="full"><Spinner /></Center>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};